/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TenderProcedureTypes = 'PublicOpen' | 'PublicInvitation' | 'PublicSelective' | 'PublicFreehand' | 'PrivateOpen' | 'PrivateInvitation' | 'PrivateDirect';

export const TenderProcedureTypes = {
    PublicOpen: 'PublicOpen' as TenderProcedureTypes,
    PublicInvitation: 'PublicInvitation' as TenderProcedureTypes,
    PublicSelective: 'PublicSelective' as TenderProcedureTypes,
    PublicFreehand: 'PublicFreehand' as TenderProcedureTypes,
    PrivateOpen: 'PrivateOpen' as TenderProcedureTypes,
    PrivateInvitation: 'PrivateInvitation' as TenderProcedureTypes,
    PrivateDirect: 'PrivateDirect' as TenderProcedureTypes
};

